<template>
  <div class="action-group-desktop col-12 row justify-between">
    <div class="action-group-search-sort row">
      <CustomExpansionItem
        class="action-group-refine-search-mobile q-mb-sm"
        :icon="sliderIcon"
        :headerStyle="{ color: 'var(--q-color-primary)' }"
        innerClass=""
        label="Filters"
        :value="showRefineSearchContainer"
        @input="$emit('update:showRefineSearchContainer', $event)"
      />
      <div class="action-group-sortby-desktop q-mb-sm q-mr-sm">
        <p class="text-primary text-weight-bolder" style="font-size: 16px; margin: 0 0 5px">Sort by</p>
        <SortSelector
          class="calculator-select q-mr-md"
          :value="sortBy"
          @input="$emit('update:sortBy', $event)"
          :options="sortOptions"
          style="width: auto"
          :disabled="ratebookLoading || (formattedVehicles && formattedVehicles.length == 0)"
          @onSortBy="$emit('sort', $event)"
          :sortOrder="sortOrder"
          @onSortOrder="$emit('sortOrder', $event)"
        />
      </div>
      <div class="action-group-sortby-mobile q-mb-sm">
        <SortSelector
          class="calculator-select q-mr-md"
          :value="sortBy"
          @input="$emit('update:sortBy', $event)"
          :label="sortBy ? void 0 : 'Sort by'"
          :options="sortOptions"
          :disabled="ratebookLoading || (formattedVehicles && formattedVehicles.length == 0)"
          @onSortBy="$emit('sort', $event)"
          :sortOrder="sortOrder"
          @onSortOrder="$emit('sortOrder', $event)"
        />
      </div>
      <LeaseTermOptions
        v-if="false"
        class="action-group-repayments q-mb-sm q-mr-lg"
        :value="leaseTerm"
        :options="leaseTermOptions"
        @input="handleLeaseTermOptions"
        :isActive="(formattedVehicles && formattedVehicles.length > 0) || hasItemsInShortList"
      />
      <RepaymentOptions
        class="action-group-repayments q-mb-sm"
        :value="repayment"
        @input="$emit('update:repayment', $event)"
        :isActive="(formattedVehicles && formattedVehicles.length > 0) || hasItemsInShortList"
      />
    </div>

    <div class="action-group-submit row" style="align-self: end">
      <QBtn outlined class="calculator-button lease-inclusion-mobile q-mr-md q-mb-sm" rounded @click="$emit('leaseInclusion')">
        Lease inclusions
      </QBtn>
      <QBtn
        :icon-right="chevronIcon"
        outlined
        class="calculator-button next-step tertiary-border q-mb-sm"
        :color="hasItemsInShortList ? 'tertiary' : undefined"
        :rounded="isCalculatorButtonRounded"
        :disabled="!hasItemsInShortList"
        @click="$emit('viewShortlist')"
      >
        View shortlist
      </QBtn>
    </div>
    <QSlideTransition>
      <div v-show="showRefineSearch" class="action-group-refine-search-container-mobile full-width">
        <QCard v-if="showRefineSearchContainer" class="action-group-refine-search-content-mobile q-my-sm q-pa-sm" flat bordered>
          <RepaymentOptions
            class="q-mb-sm"
            :value="repayment"
            @input="$emit('update:repayment', $event)"
            :isActive="(formattedVehicles && formattedVehicles.length > 0) || hasItemsInShortList"
          />
          <RefineSearchContainer
            ref="refine"
            :value="searchOptions"
            @input="$emit('update:searchOptions', $event)"
            :sortedBy="sortBy"
            :sortedOrder="sortOrder"
            :disabled="disabled"
            :leaseTerm="leaseTerm"
            @submit="$emit('search')"
          />
        </QCard>
      </div>
    </QSlideTransition>
  </div>
</template>

<script>
import { QBtn, QCard, QSlideTransition } from 'quasar';
import { evaOptions2, evaChevronRight } from '@quasar/extras/eva-icons';
import CustomExpansionItem from '../CustomExpansionItem';
import SortSelector from '../SortSelector';
import RepaymentOptions from '../RepaymentOptions';
import LeaseTermOptions from '../LeaseTermOptions';
import RefineSearchContainer from '../RefineSearch/RefineSearchContainer';

export default {
  name: 'VehicleResultActions',
  components: {
    QBtn,
    QCard,
    QSlideTransition,
    CustomExpansionItem,
    SortSelector,
    RepaymentOptions,
    LeaseTermOptions,
    RefineSearchContainer
  },
  props: {
    sortBy: {
      type: Object,
      default: null
    },
    sortOrder: {
      type: String,
      default: 'ASC'
    },
    sortOptions: {
      type: Array,
      default: () => []
    },
    ratebookLoading: {
      type: Boolean,
      default: false
    },
    formattedVehicles: {
      type: Array,
      default: () => []
    },
    repayment: {
      type: String,
      default: 'weekly'
    },
    leaseTerm: {
      type: Object,
      default: () => ({})
    },
    leaseTermOptions: {
      type: Array,
      default: () => []
    },
    hasItemsInShortList: {
      type: Boolean,
      default: false
      // Note: This prop indicates if shortlist HAS items (true = has items, false = empty)
      // Button should be enabled when hasItemsInShortList is true
    },
    isCalculatorButtonRounded: {
      type: Boolean,
      default: false
    },
    showRefineSearch: {
      type: Boolean,
      default: true
    },
    showRefineSearchContainer: {
      type: Boolean,
      default: true
    },
    searchOptions: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sliderIcon: evaOptions2,
      chevronIcon: evaChevronRight
    };
  },
  methods: {
    resetRefineSearchState() {
      const refine = this.$refs.refine;
      if (refine && typeof refine.rsm_resetLocalState === 'function') {
        refine.rsm_resetLocalState();
      } else if (refine && typeof refine.resetLocalState === 'function') {
        refine.resetLocalState();
      }
    },
    handleLeaseTermOptions(value) {
      // Emit leaseTerm change to parent - parent will handle fetchRatebook
      this.$emit('update:leaseTerm', value);
    }
  }
};
</script>
